angular.module('dnecom')
    .service('IntegrationsUtils', ['$http', '$q', function ($http, $q) {
        /**
         * Load and return accounts by types.
         *
         * @param callback
         * @param errorCallback
         */
        this.getAccountsByTypes = function (callback, errorCallback) {
            $http
                .get(Routing.generate('integrations_accounts_by_types'))
                .then(function (response) {
                    if (response.data.success) {
                        callback(response.data.accounts);
                    } else if (errorCallback) {
                        errorCallback(response);
                    }
                }, function (response) {
                    alert('There was a problem while fetching integrations.');

                    if (errorCallback) {
                        errorCallback(response);
                    }
                });
        };

        /**
         * Fetch autoresponders list.
         *
         * @param storeId
         * @param accountId
         * @param callback
         * @param errorCallback
         * @param finallyCallback
         */
        this.getAutoResponderList = function (storeId, accountId, callback, errorCallback, finallyCallback) {
            if (accountId) {
                $http
                    .post(Routing.generate('stores_get_autoresponder_lists', {
                        id: storeId,
                        accountId: accountId
                    }))
                    .then(function (response) {
                        if (response.data.success) {
                            if (callback) {
                                callback(response.data.lists);
                            }
                        } else {
                            if (errorCallback) {
                                errorCallback(response);
                            } else {
                                alert('Failed to fetch autoresponder lists: ' + response.data.message);
                            }
                        }
                    }, function (response) {
                        if (errorCallback) {
                            errorCallback(response);
                        } else {
                            alert('There was a problem while fetching autoresponders.');
                        }
                    });
            }
        };

        return this;
    }]);
